import { useMutation } from "react-query";
import { updateProducerCode } from "../../../../actions/CarrierAgreementMgmt/ProducerCodeConfig";
const useEditProdCode = () => {
  return useMutation(updateProducerCode);
};

export default useEditProdCode;
